import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4ef8a6b5&scoped=true"
import script from "./list.ts?vue&type=script&lang=ts&external"
export * from "./list.ts?vue&type=script&lang=ts&external"
import style0 from "./list.scss?vue&type=style&index=0&id=4ef8a6b5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8a6b5",
  null
  
)

export default component.exports